import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { LayoutService } from '../../../@core/data/layout.service';
import { GeneralService } from "../../../@core/data/general.service";

import { generalSettings } from '../../../../main/settings';

@Component({
  selector: "edm-dialog-contact",
  templateUrl: "./dialog-contact.component.html",
  styleUrls: ["./dialog-contact.component.scss"],
  standalone: false,
})
export class HeaderDialogContactComponent implements OnInit {

  @Input() contact!: string;

  pathBaseTranslate: string = 'theme.components.header.dialog.';

  constructor(
    private activeModal: NgbActiveModal,
    private layoutService: LayoutService,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {}

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  buttonCustomLayoutCss(): string {
    return this.layoutService.buttonCustomLayoutCss();
  }

  iconCustomLayoutClass(): string {
    return generalSettings.timelineIconsLayout + "-icon";
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + "-icons-type";
  }

  closeModal(data: any = undefined): void {
    data !== undefined && data !== null
      ? this.activeModal.close(data)
      : this.activeModal.dismiss();
  }
}
